<div class="content">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      @if (!router.url.includes('myprojects/')) {
        <li class="breadcrumb-item ms-5" style="font-size:2rem!important;"><span>{{'NAV_BAR_LEFT.MES_PROJETS' | translate}}</span></li>
      }
      @if (router.url.includes('myprojects/')) {
        <li class="breadcrumb-item ms-5" (click)="navToMesProjets()"><span>{{'NAV_BAR_LEFT.MES_PROJETS' | translate}}</span></li>
      }
      @if (utilService?.currentProjet?.nom) {
        <li (click)="navToMonProjet()" class="breadcrumb-item"><span>{{utilService?.currentProjet?.nom}}</span></li>
      }
      @if (utilService?.currentTir?.nom) {
        <li (click)="navToTir()" class="breadcrumb-item"><span>{{utilService?.currentTir?.nom}}</span></li>
      }
      @if (utilService?.currentEtape?.nom) {
        <li class="breadcrumb-item"><span>{{utilService?.currentEtape?.nom}}</span></li>
      }
    </ol>
  </nav>
</div>
